import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateFilterType } from '../constants/filters';
import { UserTicketStatusOption } from '../data/types';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { ResetFiltersButton } from './ResetFiltersButton';
import { ShowAllRecordsButton } from './ShowAllRecordsButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketListEmptyState({
  error,
  headingTypography = 'heading-200',
  trackingScreen = 'ticket-listings'
}) {
  const {
    statusFilter,
    createDateFilter,
    lastActivityFilter,
    searchString,
    conversationSearch,
    activeFilterCount,
    defaults
  } = useTicketListingsSortAndFilters();
  const isShowingEverything = statusFilter === UserTicketStatusOption.ALL && createDateFilter === DateFilterType.ALL_TIME && lastActivityFilter === DateFilterType.ALL_TIME && searchString === '' && conversationSearch === '';
  const isDefaultView = activeFilterCount === 0 && searchString === '';
  const isDateHiddenByDefault = defaults.createDateFilter !== DateFilterType.ALL_TIME;
  if (error) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: headingTypography,
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.loadError"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.loadErrorHelp"
        })
      })]
    });
  }
  if (isDefaultView) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: headingTypography,
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResults"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: isDateHiddenByDefault ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResultsDefaultFiltersHelp"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResultsDefaultStatusHelp"
        })
      }), /*#__PURE__*/_jsx(ShowAllRecordsButton, {
        screen: trackingScreen
      })]
    });
  }
  if (!isShowingEverything) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: headingTypography,
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResults"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.noResultsHelp"
        })
      }), /*#__PURE__*/_jsx(ResetFiltersButton, {
        screen: trackingScreen
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "400",
    gap: "300",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: headingTypography,
      color: "text-core-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.emptyInbox"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.emptyInboxHelp"
      })
    })]
  });
}